import { ref, reactive } from 'vue'

// Global state untuk semua tab
const tabStates = reactive({
  'dashboard': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'name',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedCustomerId: null,
    formMode: 'add',
    
    tableDateFrom: null,
    tableDateTo: null,

    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },

  'dispatch-management': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'transport_order_no',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table', // 'table', 'form', 'detail'
    selectedOrderId: null,
    formMode: 'add', // 'add' or 'edit'
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances (untuk tracking)
    componentInstances: new Map()
  },
  'transport-status': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    // Default: waybill yang barusan berubah status naik ke paling atas.
    // "updated_at" adalah kolom asli di tabel waybills (bukan field hasil
    // hitungan/join seperti "status_updated_at"), jadi tetap bisa di-sort
    // langsung di level database tanpa matiin paginasi (beda dengan
    // "status_updated_at" yang butuh scan semua data dulu - lihat
    // computedSortableFields di transport-statuses.service.ts).
    tableSortField: 'updated_at',
    tableSortOrder: 'desc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedOrderId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'waybill-entry': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'etd_datetime',
    tableSortOrder: 'desc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedOrderId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'order-management': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'order_no',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedOrderId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'm-vehicle': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'plate_number',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedVehicleId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'm-location': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'vendor_name',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedLocationId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'm-customer': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'name',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedCustomerId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'm-cargo-detail': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'cargo_contents',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedCargoDetailId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'm-vendor': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'name',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedVendorId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'm-mailing-list': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'name',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedMailingListId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
   'm-role': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 10,
    tableSortField: 'role_id',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedRoleId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'selling-tarif': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'cargo_type',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedSellingId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'buying-tarif': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'cargo_type',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedBuyingId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'container-info': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'container_no',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedContainerId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'container-inout': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'container_no',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedContainerId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'vehicle-usage-status': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'vehicle_no',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    //Navigation state
    currentView: 'table',
    selectedOrderId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'vehicle-usage-status-avarage': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'vehicle_no',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    //Navigation state
    currentView: 'table2',
    selectedContainerId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'vehicle-trip-status': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'vehicle_name',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedVehicleId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'transportation-status-by-period': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'period',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedPeriodId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'transportation-status-by-shipper': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'partner_name',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedPartnerId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'dispatch-management-by-shipper': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 100,
    tableSortField: 'total_waybill',
    tableSortOrder: 'desc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedPartnerId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'summary-trip-by-shipper': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'shipper',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'transportation-status-by-driver': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'driver_name',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedDriverId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'transportation-status-by-location': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'driver_name',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedDriverId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'transportation-status-by-vehicle': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'vehicle',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedVehicleId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  
  'report-maintenance-vehicle': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'vehicle',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedVehicleId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'vehicle-status': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'vehicle_name',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedVehicleId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'forecasted-performance': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'waybill_number',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedWaybillId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'report-form-setting': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'waybill_number',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedWaybillId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'm-user': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'user_id',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedUserId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'm-driver': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'driver_id',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedDriverId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'm-country': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'country_id',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedCountryId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'status-waiting-vehicles': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'plate_number',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Elapsed-time bucket filter dipilih dari klik kartu ringkasan
    // (day_1/day_3/day_7/day_15/day_30), null = tidak difilter.
    activeBucket: null,

    // Navigation state
    currentView: 'table',
    selectedVehicleId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'status-scheduled-vehicles-return': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'plate_number',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedVehicleId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'm-route': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'from',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedRouteId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },

  'interface-setting': {
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'module_id',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    currentView: 'table',
    selectedIdInterfaceSettings: null,
    formMode: 'add',
    formData: {},
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    componentInstances: new Map()
  },

  'i-interface-setting-detail': {
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'module_id',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    currentView: 'table',
    selectedIdInterfaceSettingDetail: null,
    formMode: 'add',
    formData: {},
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    componentInstances: new Map()
  },

  'system-setting': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'from',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedSystemSettingId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'm-cargo-type': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'cargo_type_code',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedCargoTypeId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'm-tariff-unit-management': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'unit_code',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedTariffUnitManagementId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'm-local-custom-charge': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'lcc_class',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedLocalCustomChargeId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'm-traffic-accident': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'accident_no',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedTrafficAccidentId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'm-currency': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'accident_no',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedTrafficAccidentId: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    tableSortField: 'currency_code',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedCurrencyId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
  'm-division': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'created_at',
    tableSortOrder: 'desc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedDivisionId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'm-container-code': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'container_code',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedContainerCodeId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    componentInstances: new Map(),
  },
  'report-traffic-accident': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'accident_no',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedReportTrafficAccidentId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'code-generator': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'code',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedGenerateCode: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'm-export-queue': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'name',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedExportQueue: null,
    formMode: 'add',
    
    // Form state
    formData: {},
    
    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
   'authorization': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'authorization_code',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',

    // Navigation state
    currentView: 'table',
    selectedAuthorizationId: null,
    formMode: 'add',

    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,

    // Component instances
    componentInstances: new Map()
  },
  'm-payment': {
    // Table state
    tableData: [],
    tableLoading: false,
    tableTotalCount: 0,
    tableCurrentPage: 1,
    tablePageSize: 50,
    tableSortField: 'transport_order_no',
    tableSortOrder: 'asc',
    tableFilters: {},
    tableSearchTerm: '',
    
    // Navigation state
    currentView: 'table',
    selectedPaymentId: null,
    formMode: 'add',
    
    // Form state
    formData: {},

    // Modal states
    showDeleteModal: false,
    showExportModal: false,
    deleteItem: null,
    exportItem: null,
    
    // Component instances
    componentInstances: new Map()
  },
})

// Simpan currentView awal tiap tab untuk reset saat logout
const initialTabViews = {}
Object.keys(tabStates).forEach(tabKey => {
  initialTabViews[tabKey] = tabStates[tabKey].currentView
})

// Function untuk mendapatkan state tab
export function useTabState(tabKey) {
  if (!tabStates[tabKey]) {
    console.warn(`Tab state not found for: ${tabKey}`)
    return null
  }
  
  return tabStates[tabKey]
}

// Reset semua tab ke view awal dan hilangkan data detail saat logout
export function clearAllTabStates() {
  const selectionKeys = [
    'selectedOrderId',
    'selectedVendorId',
    'selectedDriverId',
    'selectedVehicleId',
    'selectedWaybillId',
    'selectedContainerId',
    'selectedCustomerId',
    'selectedRouteId',
    'selectedLocationId',
    'selectedSellingId',
    'selectedBuyingId',
    'selectedMailingListId',
    'selectedPeriodId',
    'selectedPartnerId',
    'selectedId',
    'selectedRoleId',
    'selectedCargoDetailId'
  ]

  Object.keys(tabStates).forEach(tabKey => {
    const state = tabStates[tabKey]
    state.currentView = initialTabViews[tabKey] || 'table'
    selectionKeys.forEach(key => {
      if (key in state) {
        state[key] = null
      }
    })
    if ('formMode' in state) state.formMode = 'add'
    if ('showDeleteModal' in state) state.showDeleteModal = false
    if ('showExportModal' in state) state.showExportModal = false
    if ('deleteItem' in state) state.deleteItem = null
    if ('exportItem' in state) state.exportItem = null
  })
}

// Function untuk menyimpan state ke localStorage
export function saveTabStateToStorage() {
  try {
    const stateToSave = {}
    Object.keys(tabStates).forEach(tabKey => {
      const state = tabStates[tabKey]
      
      stateToSave[tabKey] = {
        // Table state
        tableData: state.tableData,
        tableLoading: state.tableLoading,
        tableTotalCount: state.tableTotalCount,
        tableCurrentPage: state.tableCurrentPage,
        tablePageSize: state.tablePageSize,
        tableSortField: state.tableSortField,
        tableSortOrder: state.tableSortOrder,
        tableFilters: state.tableFilters,
        tableSearchTerm: state.tableSearchTerm,
        activeBucket: state.activeBucket,

        // Navigation state
        currentView: state.currentView,
        selectedOrderId: state.selectedOrderId,
        selectedVendorId: state.selectedVendorId,
        selectedDriverId: state.selectedDriverId,
        selectedVehicleId: state.selectedVehicleId,
        selectedWaybillId: state.selectedWaybillId,
        selectedContainerId: state.selectedContainerId,
        selectedCustomerId: state.selectedCustomerId,
        selectedRouteId: state.selectedRouteId,
        selectedLocationId: state.selectedLocationId,
        selectedSellingId: state.selectedSellingId,
        selectedBuyingId: state.selectedBuyingId,
        selectedUserId: state.selectedUserId,
        selectedSystemSettingId: state.selectedSystemSettingId,
        selectedCargoTypeId: state.selectedCargoTypeId,
        selectedCargoDetailId: state.selectedCargoDetailId,
        selectedTariffUnitManagementId: state.selectedTariffUnitManagementId,
        selectedLocalCustomChargeId: state.selectedLocalCustomChargeId,
        selectedTrafficAccidentId: state.selectedTrafficAccidentId,
        selectedContainerCodeId: state.selectedContainerCodeId,
        selectedDivisionId: state.selectedDivisionId,
        selectedIdInterfaceSettings: state.selectedIdInterfaceSettings,
        selectedIdInterfaceSettingDetail: state.selectedIdInterfaceSettingDetail,
        selectedCityId: state.selectedCityId,
        selectedAuthorizationId: state.selectedAuthorizationId,
        selectedRoleId: state.selectedRoleId,
        selectedPaymentId: state.selectedPaymentId,
        formMode: state.formMode,
        // Form state
        formData: state.formData,
        
        // Modal states
        showDeleteModal: state.showDeleteModal,
        deleteItem: state.deleteItem,
        showExportModal: state.showExportModal,
        exportItem: state.exportItem,

        tableDateFrom: state.tableDateFrom,
        tableDateTo: state.tableDateTo,
      }
    })
    localStorage.setItem('tabStates', JSON.stringify(stateToSave))
  } catch (error) {
    console.error('❌ Failed to save tab states:', error)
  }
}

// Function untuk memuat state dari localStorage
export function loadTabStateFromStorage() {
  try {
    const savedState = localStorage.getItem('tabStates')
    if (savedState) {
      const parsedState = JSON.parse(savedState)
      Object.keys(parsedState).forEach(tabKey => {
        if (tabStates[tabKey]) {
          Object.assign(tabStates[tabKey], parsedState[tabKey])
        }
      })
    }
  } catch (error) {
    console.error('❌ Failed to load tab states:', error)
  }
}

// Function untuk reset state tab
export function resetTabState(tabKey) {
  if (tabStates[tabKey]) {
    const defaultSortField =
      tabKey === 'waybill-entry'
        ? 'waybill_no'
        : tabKey === 'container-info' || tabKey === 'container-inout'
          ? 'container_no'
          : tabKey === 'selling-tarif' || tabKey === 'buying-tarif'
            ? 'cargo_type'
            : tabKey === 'm-cargo-detail'
              ? 'cargo_contents'
              : tabKey === 'transport-status'
                ? 'updated_at'
                : 'transport_order_no'

    const initialState = {
      tableData: [],
      tableLoading: false,
      tableTotalCount: 0,
      tableCurrentPage: 1,
      tablePageSize: 50,
      tableSortField: defaultSortField,
      tableSortOrder: tabKey === 'transport-status' ? 'desc' : 'asc',
      tableFilters: {},
      tableSearchTerm: '',
      currentView: 'table',
      selectedOrderId: null,
      selectedCargoDetailId: null,
      formMode: 'add',
      formData: {},
      showDeleteModal: false,
      showExportModal: false,
      deleteItem: null,
      exportItem: null,
      componentInstances: new Map()
    }
    Object.assign(tabStates[tabKey], initialState)
    console.log(`🔄 Reset state for tab: ${tabKey}`)
  }
}

// Function untuk reset hanya view state ke table (tidak reset data)
export function resetViewToTable(tabKey) {
  if (tabStates[tabKey]) {
    tabStates[tabKey].currentView = 'table'
    
    // Reset appropriate ID field based on tab type
    if (tabKey === 'container-info' || tabKey === 'container-inout') {
      tabStates[tabKey].selectedContainerId = null
    } else if (tabKey === 'm-cargo-detail') {
      tabStates[tabKey].selectedCargoDetailId = null
    } else if (tabKey === 'selling-tarif') {
      tabStates[tabKey].selectedSellingId = null
    } else if (tabKey === 'buying-tarif') {
      tabStates[tabKey].selectedBuyingId = null
    } else {
      tabStates[tabKey].selectedOrderId = null
    }
    
    tabStates[tabKey].formMode = 'add'
    tabStates[tabKey].showDeleteModal = false
    tabStates[tabKey].showExportModal = false
    tabStates[tabKey].deleteItem = null
    tabStates[tabKey].exportItem = null
    // Save immediately
    saveTabStateToStorage()
  }
}

// Auto-save setiap 5 detik
setInterval(saveTabStateToStorage, 5000)

// Function untuk save state secara immediate
export function saveTabStateImmediate() {
  saveTabStateToStorage()
}

// Load state saat module diinisialisasi (untuk initial load)
loadTabStateFromStorage()

// Migrasi sekali-jalan: browser yang localStorage-nya masih nyimpen default
// sort lama untuk tab "transport-status" (transport_order_no/asc, dari
// sebelum waybill yang baru ganti status otomatis naik ke atas) dipaksa
// pindah ke default baru (updated_at/desc). Cuma jalan sekali per browser -
// kalau user sudah pernah pilih sort lain secara manual setelah migrasi ini,
// pilihannya tidak akan ditimpa lagi.
try {
  // v2: dinaikkan lagi karena v1 kemungkinan sudah "kepakai" (flag keset)
  // sebelum benar-benar nempel di sebagian browser - paksa jalan ulang
  // sekali lagi biar semua browser pasti ke-reset ke default yang benar.
  const MIGRATION_KEY = 'transportStatusSortMigrationV2'
  if (!localStorage.getItem(MIGRATION_KEY)) {
    if (tabStates['transport-status']) {
      tabStates['transport-status'].tableSortField = 'updated_at'
      tabStates['transport-status'].tableSortOrder = 'desc'
      saveTabStateToStorage()
    }
    localStorage.setItem(MIGRATION_KEY, '1')
  }
} catch (error) {
  console.error('❌ Failed to migrate transport-status sort default:', error)
}

// Migrasi sekali-jalan: browser yang localStorage-nya masih nyimpen
// tablePageSize lama (50) untuk tab "dispatch-management-by-shipper"
// dipaksa pindah ke default baru (100). Cuma jalan sekali per browser -
// kalau user sudah pernah ganti page size secara manual setelah migrasi
// ini, pilihannya tidak akan ditimpa lagi.
try {
  const PAGE_SIZE_MIGRATION_KEY = 'dispatchManagementByShipperPageSizeMigrationV1'
  if (!localStorage.getItem(PAGE_SIZE_MIGRATION_KEY)) {
    if (tabStates['dispatch-management-by-shipper']) {
      tabStates['dispatch-management-by-shipper'].tablePageSize = 100
      saveTabStateToStorage()
    }
    localStorage.setItem(PAGE_SIZE_MIGRATION_KEY, '1')
  }
} catch (error) {
  console.error('❌ Failed to migrate dispatch-management-by-shipper page size default:', error)
}

// Function untuk memuat state untuk tab tertentu
export function loadTabStateForTab(tabKey) {
  try {
    const savedState = localStorage.getItem('tabStates')
    if (savedState) {
      const parsedState = JSON.parse(savedState)
      if (parsedState[tabKey] && tabStates[tabKey]) {
        Object.assign(tabStates[tabKey], parsedState[tabKey])
      }
    }
  } catch (error) {
    console.error('❌ Failed to load tab state:', error)
  }
}

export default tabStates
